import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  advertisersList: [],
  status: 'idle',
  error: null,
};

const advertisersListSlice = createSlice({
  name: 'advertisersList',
  initialState,
  reducers: {
    setAdvertisersList: (state, action) => {
      state.advertisersList = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setAdvertisersList, setError, setLoading } =
  advertisersListSlice.actions;
export default advertisersListSlice.reducer;
